import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { CeuAssessmentComponent } from './courses/purchased-course/ceu-assessment/ceu-assessment.component';
import { CourseViewerComponent } from './courses/purchased-course/course-viewer.component';
import { CourseMaterialsComponent } from './courses/purchased-course/materials/course-materials.component';

@NgModule({
  declarations:[
    CourseViewerComponent,
    CourseMaterialsComponent,
    CeuAssessmentComponent,
  ],
  entryComponents:[
    CeuAssessmentComponent
  ],
  imports:[
    NgbModalModule,
    ApplicationPipesModule,
    RouterModule.forChild([
      { path: '', component: CourseViewerComponent }
    ])
  ],
  exports:[],
})
export class OnDemandModule{}
